import { handleActions } from 'redux-actions';
import reducersUtils from 'state/utils';
import actions from 'state/direct-order-recurring/holidays/actionCreators';

import initialState from 'state/direct-order-recurring/holidays/initial.state';

const holidays = handleActions(
  {
    [reducersUtils.RESET_ORDER_STATE]: () => initialState,
    [actions.setHolidays]: (_, { payload: { days } }) => days,
  },
  initialState
);

export default holidays;
